// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "DeviceSettingsModule__textCenter__w0T9T";
export const table = "DeviceSettingsModule__table__2mxlK";
export const tableInner = "DeviceSettingsModule__tableInner__BMBcI";
export const headerRow = "DeviceSettingsModule__headerRow__BVKjk";
export const white = "DeviceSettingsModule__white__w1xTO";
export const headerCell = "DeviceSettingsModule__headerCell__p5QeM";
export const responsiveTitle = "DeviceSettingsModule__responsiveTitle__jpoN-";
export const responsiveTitleText = "DeviceSettingsModule__responsiveTitleText__QiYJ-";
export const headerTitle = "DeviceSettingsModule__headerTitle__FzV5A";
export const sortingWrapper = "DeviceSettingsModule__sortingWrapper__y0l2G";
export const withHelpText = "DeviceSettingsModule__withHelpText__KsrYG";
export const up = "DeviceSettingsModule__up__198op";
export const down = "DeviceSettingsModule__down__-1Gf2";
export const body = "DeviceSettingsModule__body__CVzZp";
export const row = "DeviceSettingsModule__row__c05dN";
export const cell = "DeviceSettingsModule__cell__5mZxz";
export const footer = "DeviceSettingsModule__footer__M+2IV";
export const paginatorWrapper = "DeviceSettingsModule__paginatorWrapper__KrOZT";
export const pageSizeSelectorWrapper = "DeviceSettingsModule__pageSizeSelectorWrapper__JKlR7";
export const tooltipIconWrapper = "DeviceSettingsModule__tooltipIconWrapper__IgCtt";
export const debtsAccountDetails = "DeviceSettingsModule__debtsAccountDetails__0tlKR";
export const creditAccountDetails = "DeviceSettingsModule__creditAccountDetails__7LCHr";
export const accountsTable = "DeviceSettingsModule__accountsTable__XufXG";
export const pointing = "DeviceSettingsModule__pointing__Id+Ak";
export const emptyState = "DeviceSettingsModule__emptyState__ElsK5 BalanceAccountSettingsModule__emptyState__shYhk";
export const deviceTable = "DeviceSettingsModule__deviceTable__MbPDq";